export const css = {
    root: '_35jix86F',
    loading: '_3FKRdf9o',
    buttons: '_2mdNIoPW',
    oneaction: '_2CXr3Ef3',
    timerblock: '_1HOEwAUe',
    timer: '_1E1ciIKP',
    instruct: '_3SjeNy6j',
    table: '_4P4N6PhO',
    tableHead: 'nHfPbDtB',
    question: '_2Mp0tpD9',
    marked: 'NNVMJIHU',
    status: 'AUGIcJ0_',
    complete: '_6o2N4gp5',
    incomplete: '_3ZQgiGh5',
    row: '_2Q3-iXSn',
    oddRow: 'MK3uPRWA',
    ' _key': 'quiz-widgets/pretest-review'
};
export default css;
